// extracted by mini-css-extract-plugin
export default {"ingredientBox":"IngredientAttribution_ingredientBox__YWmIg","notSelectable":"IngredientAttribution_notSelectable__HPEZO"};